module.exports = __webpack_public_path__ + "img/50.3c0cbd0f.jpg";